export const badgesModal = 'manage-badges';
export const shareUrlModal = 'share-url-modal';
export const successMessageNotification = 'success-message';
export const profilePreviewNotification = 'profile-preview-notification';
